import { generateId } from 'utils/helpers';
import { CropTableProps } from 'utils/types';
import { FieldProps } from 'features/Croptimizer/types';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

export interface DuplicateFieldProps {
  currentph: string;
  targetph: string;
  currentSec: string;
  area: string;
  phAvg: string;
  soilType: string;
  sec: string;
  fineDry: string;
  om: string;
  n: string;
  p: string;
  k: string;
  s: string;
  tableData: CropTableProps[];
  productType: string;
  nv: string;
  mt: string;
}

interface FieldObject {
  currentphI: string;
  targetphI: string;
  currentSecI: string;
  areaI: string;
  phAvgI: string;
  soilTypeI: string;
  secI: string;
  fineDryI: string;
  omI: string;
  nI: string;
  pI: string;
  kI: string;
  sI: string;
  tableDataI: CropTableProps[];
  productTypeI: string;
  nvI: string;
  mtI: string;
  targetSecI: string;
  surfaceI: string;
}

export const useDuplicateField = () => {
  const { setFields, setActiveTabCrop } = useCroptimizer();

  const createFieldObject = (props: DuplicateFieldProps): FieldObject => ({
    currentphI: props.currentph,
    targetphI: props.targetph,
    currentSecI: props.currentSec,
    areaI: props.area,
    phAvgI: props.phAvg,
    soilTypeI: props.soilType,
    secI: props.sec,
    fineDryI: props.fineDry,
    omI: props.om,
    nI: props.n,
    pI: props.p,
    kI: props.k,
    sI: props.s,
    tableDataI: props.tableData,
    productTypeI: props.productType,
    nvI: props.nv,
    mtI: props.mt,
    targetSecI: '',
    surfaceI: '',
  });

  const duplicateField = (props: DuplicateFieldProps): void => {
    const newFieldId = generateId();
    
    const newField: FieldProps = {
      id: newFieldId,
      title: '',
      object: createFieldObject(props),
    };

    setFields((prevFields: FieldProps[]) => [...prevFields, newField]);
    setActiveTabCrop(newFieldId);
  };

  return {
    duplicateField,
  };
};